<div>
  @if (alertInfo.show) {
    <ngb-alert [type]="alertInfo.type" (closed)="alertInfo.show = false" class="mb-3">
      <strong>{{ alertInfo.type === 'danger' ? 'Error!' : 'Success!' }}</strong>
      <div [innerHTML]="alertInfo.message"></div>
    </ngb-alert>
  }

  <form [formGroup]="form" class="mb-3">
    <div class="row">
      <div class="col-sm-4">
        <input-field
          [label]="'Name'"
          [placeholder]="'First Name'"
          [inputFormControl]="getFirstNameControl()"
          [readonly]="readonly">
      </input-field>
    </div>
    <div class="col-sm-4">
      <input-field
        [label]="'Surname'"
        [placeholder]="'Last Name'"
        [inputFormControl]="getLastNameControl()"
        [readonly]="readonly">
    </input-field>
  </div>
  <div class="col-sm-4">
    <input-field
      [label]="'Date of Birth'"
      [inputFormControl]="getBirthdateControl()"
      [type]="'date'"
      [readonly]="readonly">
  </input-field>
</div>
</div>
<div class="row">
  <div class="col-sm-12">
    <input-field
      [label]="'Address line 1'"
      [placeholder]="'Address'"
      [inputFormControl]="getAddressLine1Control()"
      [readonly]="readonly">
  </input-field>
</div>
</div>
<div class="row">
  <div class="col-sm-12">
    <input-field
      [label]="'Address line 2'"
      [placeholder]="'Address'"
      [inputFormControl]="getAddressLine2Control()"
      [readonly]="readonly">
  </input-field>
</div>
</div>
<div class="row">
  <div class="col-sm-4">
    <input-field
      [label]="'Zip code'"
      [placeholder]="'Zip code'"
      [inputFormControl]="getZipCodeControl()"
      [readonly]="readonly">
  </input-field>
</div>
<div class="col-sm-4">
  <input-field
    [label]="'City'"
    [placeholder]="'City'"
    [inputFormControl]="getCityControl()"
    [readonly]="readonly">
</input-field>
</div>
<div class="col-sm-4">
  <select-field
    [label]="'Country'"
    [selectFormControl]="getCountryIdControl()"
    [options]="countries"
    [readonly]="readonly">
  </select-field>
</div>
</div>


</form>
</div>
